export enum DatabaseType {
    abandonedMines = 0,
    assessment = 1,
    drillHoles = 2,
    mineralInventory = 3,
    publications = 4,
    allDatabases = 5
}